var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupStep7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Steeper/07 Done") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 19.9998818 0 19.9998818 19.999744 0 19.999744"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Steeper/07-Done",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7328,6.89534401 L9.1918,11.437344 L7.2468,9.49334401 C6.8868,9.13134401 6.2988,9.13334401 5.9408,9.49334401 C5.5808,9.85334401 5.5808,10.439344 5.9408,10.799344 L8.5378,13.398344 C8.7128,13.572344 8.9448,13.669344 9.1918,13.669344 C9.4378,13.669344 9.6698,13.572344 9.8438,13.398344 L15.0388,8.20234401 C15.3988,7.84234401 15.3988,7.25534401 15.0388,6.89534401 C14.6798,6.53534401 14.0918,6.53334401 13.7328,6.89534401",
    id: "Fill-1",
    fill: "current"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0318,5.70674401 C18.7938,5.20774401 18.1958,4.99474401 17.6978,5.23174401 C17.1978,5.46874401 16.9848,6.06674401 17.2228,6.56574401 C18.0678,8.34474401 18.2268,10.364744 17.6728,12.254744 C17.1168,14.144744 15.8898,15.755744 14.2148,16.794744 C12.5418,17.834744 10.5518,18.215744 8.6128,17.875744 C6.6738,17.532744 4.9338,16.492744 3.7158,14.945744 C2.4978,13.396744 1.8958,11.462744 2.0188,9.49774401 C2.1418,7.53174401 2.9818,5.68674401 4.3848,4.30474401 C5.7858,2.92374401 7.6428,2.10874401 9.6108,2.01174401 C11.5798,1.90874401 13.5048,2.54574401 15.0338,3.78574401 C15.4648,4.13274401 16.0948,4.06574401 16.4428,3.63774401 C16.7908,3.20774401 16.7248,2.57674401 16.2948,2.22874401 C14.3808,0.678744012 11.9858,-0.102255988 9.5128,0.0107440125 C7.0518,0.131744012 4.7308,1.14974401 2.9788,2.87974401 C1.2248,4.60774401 0.1748,6.91374401 0.0198,9.37274401 C-0.1352,11.828744 0.6188,14.248744 2.1408,16.183744 C3.6648,18.118744 5.8398,19.419744 8.2648,19.846744 C8.8428,19.949744 9.4248,19.999744 10.0048,19.999744 C11.8538,19.999744 13.6768,19.486744 15.2708,18.496744 C17.3638,17.197744 18.8998,15.181744 19.5928,12.819744 C20.2878,10.456744 20.0878,7.93074401 19.0318,5.70674401",
    id: "Fill-3",
    fill: "current"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupStep7);
export default __webpack_public_path__ + "static/media/signup-step-7.ed460d1dea0790454ac32c3b80b8a98f.svg";
export { ForwardRef as ReactComponent };